
angular.module('common.template.condition.popup', ['pascalprecht.translate','common.filter.description', 'common.config', 'taric.model.measure']).controller('ConditionPopupController',
    function (CONSTANTS, $uibModalInstance, measureConditionHeadResult, $translate, MeasureForNomenclatureSearchModel, $filter) {
        var conditionPopupCtrl = this;
        conditionPopupCtrl.dateFormat = CONSTANTS.dateFormat;
        conditionPopupCtrl.itemsPerPage = CONSTANTS.rowsPerPage;
        conditionPopupCtrl.currentPage = 1;
        conditionPopupCtrl.numberOfConditionRows = measureConditionHeadResult.count;
        conditionPopupCtrl.createMeasureConditionRow = function (measureConditionHead) {
            var conditionRow = {};
            conditionRow.type = measureConditionHead.type;
            conditionRow.additionalCode = measureConditionHead.additionalCode;
            conditionRow.startDate = measureConditionHead.startDate;
            conditionRow.endDate = measureConditionHead.endDate;
            conditionRow.conditionDocuments = measureConditionHead.conditionDocuments;
            conditionRow.quotaOrderNumber = measureConditionHead.quotaOrderNumber;
            conditionRow.geographicalAreaId = measureConditionHead.geographicalAreaId;

            // Document conditions
            conditionRow.documentConditions = [];

            // Component conditions
            conditionRow.componentConditions = [];

            // Price conditions
            conditionRow.priceConditions = [];

            // Credibility conditions
            conditionRow.credibilityConditions = [];

            // Quantity conditions
            conditionRow.quantityConditions = [];

            var documentIdx = 0;
            var priceIdx = 0;
            var componentIdx = 0;
            var credibilityIdx = 0;
            var quantityIdx = 0;

            for (let i = 0; i < measureConditionHead.conditionDocuments.length; i++) {
                switch (measureConditionHead.conditionDocuments[i].code) {
                    case "0":
                    case "1":
                    case "2":
                    case "3":
                    case "4":
                    case "5":
                    case "6":
                    case "7":
                    case "8":
                    case "9":
                    case "00":
                    case "01":
                    case "02":
                    case "03":
                    case "04":
                    case "05":
                    case "06":
                    case "07":
                    case "08":
                    case "09":
                    case "A":
                    case "B":
                    case "C":
                    case "H":
                    case "K":
                    case "Q":
                    case "W":
                    case "Y":
                    case "YA":
                    case "YB":
                    case "YC":
                    case "YD":
                    case "YE":
                    case "YF":
                    case "YG":
                    case "YH":
                    case "Z":
                    case "P":
                        var idx = 0;
                        var componentsExist = false;
                        for (idx = 0; idx < measureConditionHead.conditionDocuments[i].documents.length; idx++) {
                            if ($filter('description')(measureConditionHead.conditionDocuments[i].documents[idx].dutyExpressionDescriptions)) {
                                componentsExist = true;
                                break;
                            }
                        }
                        if (componentsExist) {
                            conditionRow.componentConditions[componentIdx] = measureConditionHead.conditionDocuments[i];
                            componentIdx++;
                        } else {
                            conditionRow.documentConditions[documentIdx] = measureConditionHead.conditionDocuments[i];
                            documentIdx++;
                        }
                        break;

                    case "F":
                    case "G":
                    case "L":
                    case "M":
                    case "N":
                    case "V":
                        conditionRow.priceConditions[priceIdx] = measureConditionHead.conditionDocuments[i];
                        priceIdx++;
                        break;

                    case "R":
                    case "S":
                    case "U":
                    case "J":
                    case "O":
                    case "X":
                        conditionRow.credibilityConditions[credibilityIdx] = measureConditionHead.conditionDocuments[i];
                        credibilityIdx++;
                        break;

                    case "E":
                    case "I":
                        conditionRow.quantityConditions[quantityIdx] = measureConditionHead.conditionDocuments[i];
                        quantityIdx++;
                        break;

                    default:
                        break;
                }

            }

            return conditionRow;
        };

        conditionPopupCtrl.loadData = function (items) {
            conditionPopupCtrl.rows = [];
            items.forEach(function(measureConditionHead){
                conditionPopupCtrl.rows.push(conditionPopupCtrl.createMeasureConditionRow(measureConditionHead));
            });
        };

        conditionPopupCtrl.loadData(measureConditionHeadResult.items);

        //This method should be used only for the button 'VIEW CONDITIONS' in the use case Query measures for nomenclature
        conditionPopupCtrl.measureConditionPageChanged = function(page){
            conditionPopupCtrl.loadingConditions = true;
            MeasureForNomenclatureSearchModel.queryMeasureConditionsForNomenclature(page).then(function(result){
                conditionPopupCtrl.loadData(result.items);
                conditionPopupCtrl.loadingConditions = false;
            }, function(error){
                conditionPopupCtrl.loadingConditions = false;
                conditionPopupCtrl.errorCode = error.data.code;
                conditionPopupCtrl.errorParams = error.data.params;
                conditionPopupCtrl.errorType = error.data.type;
            });
        };

        conditionPopupCtrl.close = function () {
            $uibModalInstance.dismiss('Close');
        };

    });



// WEBPACK FOOTER //
// ./app/common/popup/condition/condition-popup.js